import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 驗證電子郵件驗證碼
 */
const VerifyMailCode = [
    'POST',
    RouteUrlList.API_VerifyMailCode.path,
    {},
    200,
    {
        status: true,
        title: '資料載入成功',
        message: '取得成功',
        errorCode: '',
        isReachedVerifyMaxTry: false
    }
];
export default VerifyMailCode;
